























































import { isNull } from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { PrescriptionType } from '@/store/folder/types';

const Props = Vue.extend({
	props: {
		isPrescription: {
			type: Boolean,
			default: false
		},
		returnFunction: {
			type: Function,
			default: null
		},
		libellePopInRetour: {
			type: String,
			default: 'Attention, vos modifications vont être perdues. Souhaitez-vous retourner à l’accueil du service sans enregistrer ?'
		}
	}
});

@Component
export default class PopInRetour extends Props {
	@Getter('infosVaccinationFolder/getPrescription') prescription: PrescriptionType | undefined;

	popinDialog = false;

	clearFolderStore() {
		this.$store.dispatch('infosVaccinationFolder/cleanVaccinationFolder');
		this.$router.push({
			name: 'accueil',
			query: Object.assign({}, this.$router.currentRoute.query)
		});
	}

	onClickFunction() {
		return !isNull(this.returnFunction) ? this.returnFunction() : this.clearFolderStore();
	}
}
